(function (st, $, undefined) {
	st.getFromJson = function (jsonVal) {
		jsonVal = jsonVal.fields;
		var arr = new Array();
		for (var i = 0; i < jsonVal.FCount; ++i) {
			var fld = jsonVal.FItems[i].fields;
			var boja = fld.FBoja;
			var hexBoja = boja.toString(16);
			var zeroes = 6 - hexBoja.length;
			for (var j = 0; j < zeroes; ++j)
				hexBoja = "0" + hexBoja;
			hexBoja = hexBoja.substring(4,6) + hexBoja.substring(2, 4) + hexBoja.substring(0, 2);
			
			arr.push({
				id: i,
				boja: hexBoja,
				naziv: fld.FNaziv,
				zakljucan: fld.FZakljucan,
				opcije: fld.FOpcije
			});
		}
		
		var statusi = {
			items: arr,
			getById: function (id) {
				return arr[id + 1];
			}
		};
		return statusi;
	};
	
	st.getStatusIzOpcija = function(opcije) {
		var status = 0;
		var matches = opcije.match(/\d+/);
		if (matches != null && matches.length > 0)
			status = parseInt(matches[0], 10);
		return status;
	};
} (window.VpStatusi = window.VpStatusi || {}, jQuery));